import { put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import {
  REQUEST,
  fetchSuccess,
  fetchFailure
} from '../../actions/forecasts/list';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

export function* fetchForecastsRequest(action) {
  try {
    const { 
      page = 0, 
      rowsPerPage = 10, 
      sortColumn = 'created_at', 
      sortDirection = 'desc', 
      modelId = null,
      limit = null
    } = action.payload || {};
    
    const params = {
      page,
      per_page: limit || rowsPerPage,
      sort_column: sortColumn,
      sort_direction: sortDirection
    };
    
    // Add model_id filter if provided
    if (modelId) {
      params.model_id = modelId;
    }
    
    // Get headers using the utility function
    const headers = getLocalUser();
    
    if (!headers.Authorization) {
      throw new Error('Authentication token not found');
    }
    
    // Make the API call
    const response = yield axios.get(`${config.API_URL}/forecast/get_forecasts`, {
      params,
      headers
    });
    
    // If successful, dispatch the success action
    yield put(fetchSuccess(response.data.data));
    
  } catch (error) {
    // If there's an error, dispatch the error action
    yield put(ErrorAction(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchForecastsRequest);
} 